import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, throwError } from 'rxjs';
import { catchError, takeUntil } from 'rxjs/operators';

import { NotifyService } from '@fry/lib/utils';

import { EditorBookingItemTreeStore } from '../editor-booking-item-tree/editor-booking-item-tree.store';


@Component({
    selector: 'eas-editor-booking-item-tree-edit',
    templateUrl: './editor-booking-item-tree-edit.component.html',
    styleUrls: ['./editor-booking-item-tree-edit.component.css'],
    standalone: false
})
export class EditorBookingItemTreeEditComponent implements OnInit, OnDestroy {
  private destroyed$ = new Subject<void>();

  constructor(
    private route: ActivatedRoute,
    private notify: NotifyService,
    private itemTreeStore: EditorBookingItemTreeStore
  ) {

  }

  ngOnInit() {
    this.route.data.pipe(
      takeUntil(this.destroyed$),
      catchError(error => {
        this.notify.error(error);
        return throwError(error);
      })
    ).subscribe(data => {
      this.itemTreeStore.initializeFromBookingItem(data.bookingItem);
    });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
